module.exports = global["Vue"] = require("-!./vue.common.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Vue!./~/vue/dist/vue.common.js
// module id = 977
// module chunks = 2